const terumotData = [
  {
    title: "תורמים ומתברכים והקרן קיימת לעד",
    description:
      "אנו שמחים מאוד על רצונכם להיות שותפים עמנו במפעל איחוד התלמודים! בתרומתכם אתם שותפים בפיתוח דרכי הלימוד של תורת ארץ ישראל, במחקר, הפצת שיעורים ותכנים, הוצאה לאור והחזקת בית מדרש ללומדי ירושלמי. את תרומתכם תוכלו לרשום לזכות יקירכם ולרפואתם או להנציח את יקיריכם. ישנן מספר דרכים שבאמצעותן תוכלו לתרום",
    btnTitle: "ניתן לתרום בכל דרך שתבחרו:",
    options: [
      {
        image: "/candle.png",
        text: "רוצים שנחזור אליכם? שלחו לנו הודעה",
        link: "https://wa.me/972526146659?text=שלום וברכה! אני רוצה להיות שותף, אשמח שתחזרו אלי", // WhatsApp link with phone number
      },
      {
        image: "/book.png",
        text: "לתרומה מאובטחת באשראי",
        link: "https://www.trumot.net/Form/1564?media=wa", // Link for secure donation
      },
      {
        image: "/sky.png",
        text: "לתרומה טלפונית",
        link: "tel:+972526146659", // Telephone link for direct calling
      },
    ],
  },
];
export default terumotData;
